import { render, staticRenderFns } from "./BackToList.vue?vue&type=template&id=1eca230d&scoped=true&"
import script from "./BackToList.vue?vue&type=script&lang=js&"
export * from "./BackToList.vue?vue&type=script&lang=js&"
import style0 from "./BackToList.vue?vue&type=style&index=0&id=1eca230d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca230d",
  null
  
)

export default component.exports